module.exports = __webpack_public_path__ + "static/img/added.20f636e3.png";